







































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import { FieldType, Filter, CompareType } from "@/store/entities/filter";
import PageRequest from "@/store/entities/page-request";
import EditUser from "./edit-user.vue";
import Ajax from '@/lib/ajax'
import userAjax from '@/lib/userAjax'
@Component({
    components: { EditUser }
})
export default class Users extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  filters: Filter[] = [
    {
      Type: FieldType.String,
      Value: "",
      FieldName: "UserName",
      CompareType: CompareType.Contains
    },
    {
      Type: FieldType.String,
      Value: "",
      FieldName: "Name",
      CompareType: CompareType.Contains
    },
    {
      Type: FieldType.DataRange,
      Value: "",
      FieldName: "CreationTime",
      CompareType: CompareType.Contains
    },
    {
      Type: FieldType.Boolean,
      Value: null,
      FieldName: "IsActive",
      CompareType: CompareType.Equal
    },
    {//地区筛选
      Type: FieldType.String,
      Value: [],
      FieldName: "selectDistrict",
      CompareType: CompareType.Contains
    }
  ];
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  get list() {
    return this.$store.state.user.list;
  }
  get loading() {
    return this.$store.state.user.loading;
  }
  create() {
    this.createModalShow = true;
  }
  isActiveChange(val: string) {
    if (val === "Actived") {
      this.filters[3].Value = true;
    } else if (val === "NoActive") {
      this.filters[3].Value = false;
    } else {
      this.filters[3].Value = null;
    }
  }
  pageChange(page: number) {
    this.$store.commit("user/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("user/setPageSize", pagesize);
    this.getpage();
  }
  searchUser() {
    this.$store.commit("user/setCurrentPage", 1);
		this.getpage();
  }
  async getpage() {
    let where = Util.buildFilters(this.filters);
    let pagerequest = new PageRequest();
		pagerequest.maxResultCount = this.pageSize;
    pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    pagerequest.where = where;
    await this.$store.dispatch({
      type: "user/getAll",
      data: pagerequest
    });
  }
  get pageSize() {
    return this.$store.state.user.pageSize;
  }
  get totalCount() {
    return this.$store.state.user.totalCount;
  }
  get currentPage() {
    return this.$store.state.user.currentPage;
  }
  columns = [
    {
      title: "用户名",
      key: "userName"
    },
    {
      title: "姓名",
      key: "name"
    },
    {
      title: "职位",
      key: "position"
    },
    {
      title: "激活状态",
      render: (h: any, params: any) => {
        return h("span", params.row.isActive ? "已激活" : "未激活");
      }
    },
    {
      title: "创建时间",
      key: "creationTime",
      render: (h: any, params: any) => {
        if (params.row.creationTime) {
          return h(
            "span",
            new Date(
              params.row.creationTime.replace("T", " ")
            ).toLocaleDateString()
          );
        }
      }
    },
    {
      title: "上一次登录时间",
      render: (h: any, params: any) => {
        if (params.row.lastLoginTime) {
          return h(
            "span",
            new Date(
              params.row.lastLoginTime.replace("T", " ")
            ).toLocaleString()
          );
        }
      }
    },
    {
      title: "操作",
      key: "Actions",
      align: 'center',
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small"
              },
              on: {
                click: () => {
                  this.$store.commit("user/edit", params.row);
                  this.edit();
                }
              }
            },
            "编辑角色"
          ),
          // h(
          //   "Button",
          //   {
          //     props: {
          //       type: "error",
          //       size: "small"
          //     },
          //     on: {
          //       click: async () => {
          //         this.$Modal.confirm({
          //           title: "用户删除",
          //           content: "是否删除此用户",
          //           okText: "是",
          //           cancelText: "取消",
          //           onOk: async () => {
          //             await this.$store.dispatch({
          //               type: "user/delete",
          //               data: params.row
          //             });
          //             await this.getpage();
          //           }
          //         });
          //       }
          //     }
          //   },
          //   "删除"
          // )
        ]);
      }
    }
  ];
  async created() {
    this.filters[4].Value = this.$store.state.session.user.selectDistrict.split(',')//获取当前用户所属地区
    this.getpage();
    let reponse = await userAjax.get('/api/services/app/Role/GetAll?maxResultCount=100&skipCount=0&where=allowLowEdit%3Dtrue')
    this.$store.state.user.roles = reponse.data.result.items;
  }
}
